import { ESessionActionTypes } from './types';
import { ISessionToken } from '../../types/session';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Запрос за токеном сессии
 */
export const setUsersSessionPending = actionGenerator<ESessionActionTypes.SetPending, void>(
  ESessionActionTypes.SetPending,
);

/**
 * Установить токен сессии
 */
export const setUsersSessionSucceed = actionGenerator<ESessionActionTypes.SetSucceed, ISessionToken>(
  ESessionActionTypes.SetSucceed,
);

/**
 * Установить ошибку запроса токена сессии
 */
export const setUsersSessionFailed = actionGenerator<ESessionActionTypes.SetFailed, void>(
  ESessionActionTypes.SetFailed,
);
